<template>
    <div class="dropzone-outer">
        <div class="text-center w-full" v-if="!preview">
            <vue-dropzone :id="inputName"
                          ref="myVueDropzone"
                          :include-styling="false"
                          :options="dropzoneOptions"
                          :use-custom-slot="true"
                          @vdropzone-success="onVdropzoneSuccess"
                          @vdropzone-error="onVdropzoneError">
                <svg class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48">
                    <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                          stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p class="mt-1 text-sm text-gray-600">
                    <span class="upload-link cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition duration-150 ease-in-out border-none" ref="uploadButton">
                        {{translations.buttonDesc}}
                    </span>
                    {{translations.buttonSubDesc}}
                </p>
                <p class="mt-1 text-xs text-gray-500 mb-2">
                    {{filetypes}}
                </p>
                <div v-if="info.type" class="relative">
                    <flash :flash-type="info.type" :flash-message="info.message"></flash>
                </div>
            </vue-dropzone>
        </div>
        <div v-else class="flex justify-between form-control">
            <nav class="pr-4">
                <div class="group side-nav cursor-pointer" @click="removeUpload">
                    <span class="truncate">{{translations.delete}}</span>
                </div>
                <div class="group side-nav cursor-pointer" @click="showModal = true">
                    <span class="truncate">{{translations.show}}</span>
                </div>
            </nav>
            <div class="expand">
                <img :src="preview" style="max-height: 500px" />
            </div>
        </div>
        <input type="hidden" :name="inputName" v-model="filename" class="hidden-dropzone-input">

        <modal :showing="showModal"
               @close="showModal = false"
               :showClose="true"
               modal-classes="md:w-auto"
               :buttons="[]">
            <img :src="preview" width="100%" style="height: calc(100vh - 100px); width: auto" />
<!--            <div class="sm:flex sm:items-start">
                <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                    <svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                </div>
                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                        Deactivate account
                    </h3>
                    <div class="mt-2">
                        <p class="text-sm leading-5 text-gray-500">
                            Are you sure you want to deactivate your account? All of your data will be permanently removed. This action cannot be undone.
                        </p>
                    </div>
                </div>
            </div>-->
        </modal>
    </div>
</template>
<script>
    import modal from '../modal';
    import vue2Dropzone from 'vue2-dropzone'
    import flash from './flash';

    const typeMap = {
	    PNG: 'image/png',
	    PDF: 'application/pdf',
	    JPG: 'image/jpeg'
    };
    export default {
        props: {
	        user: {type: String, default: '0'},
	        endpoint: {type: String, default: 'verified_business_document'},
	        translations: {type: Object, default: {}},
	        filetypes: {type: String, default: 'PDF / PNG / JPG'},
	        inputName: {type: String, default: 'default'},
	        defaultFilename: {type: String, default: 'default'},
	        value: {type: String, default: ''},
	        multiple: {type: Boolean, default: false},
	        filesize: {type: Number, default: 2},
        },
        components: {
            vueDropzone: vue2Dropzone,
	        flash: flash,
	        modal
        },
        data: function () {
            return {
                dropzoneOptions: {
                    url: `/api/forms/${this.endpoint}/${this.user}`,
                    thumbnailWidth: 150,
                    maxFilesize: this.filesize,
	                dictFileTooBig: this.translations.fileTooBig,
	                previewTemplate: '<template></template>',
                    uploadMultiple: !!this.multiple,
                    clickable: `#${this.inputName} .upload-link`,
	                acceptedFiles: this.getFileType(),
                },
                filename: this.value || this.defaultFilename,
                preview: this.value ? `/api/image/${this.user}/${this.value}` : '',
	            previewType: 'jpg',
	            showModal: false,
                info: {
                	type: '',
                    message: ''
                },
                buttons: [
                    {
                        label: 'Ja',
                        class: 'focus:border-red-700 focus:shadow-outline-red bg-red-600 hover:bg-red-500 text-white',
                        onClick: this.removeUpload
                    }, {
                        label: 'Nein'
                    }
                ]
            }
        },
        mounted() {
        },
	    methods: {
            onVdropzoneSuccess: function(file, response) {
	            const typeIndex = Object.values(typeMap).indexOf(file.type);
	            if (typeIndex !== -1) {
	            	this.previewType = Object.keys(typeMap)[typeIndex];
                }
	            this.filename = response.filename;
	            this.preview = this.previewType !== 'PDF' ? file.dataURL : `/api/image/${this.user}/${response.filename}`;
	            this.info.type = '';
	            this.info.message = '';
            },
	        onVdropzoneError(file, message, xhr) {
                this.info.type = 'error';
                this.info.message = message;
            },
		    removeUpload() {
			    this.filename = '';
			    this.preview = '';
            },
            getFileType() {
	            return this.filetypes.split(' / ')
                    .filter(type => typeMap[type])
                    .map(type => typeMap[type])
                    .join(',');
            }
        }
    }
</script>
<style lang="scss">
    @import '../node_modules/vue-tailwind-modal/src/css/modal.css';
    .bg-smoke-800 {
        background-color: rgba(0,0,0,.2);
        z-index: 1000;
    }
</style>
